export class DocumentExtractionFactory {
  constructor(instance) {
    this.instance = instance;
  }

  extractDocumentData(file) {
    if (!file) {
      throw new Error('Arquivo não fornecido');
    }

    const formData = new FormData();
    formData.append('file', file);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    return this.instance.post('/v1/ia/financeiro/extract', formData, config);
  }
}

export default DocumentExtractionFactory;
